var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tab-size character-style-1"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('div',{staticClass:"base-animation"})])])}
var staticRenderFns = []

export { render, staticRenderFns }